import { render, staticRenderFns } from "./emailbody.vue?vue&type=template&id=36f0659d"
import script from "./emailbody.vue?vue&type=script&lang=js"
export * from "./emailbody.vue?vue&type=script&lang=js"
import style0 from "./emailbody.vue?vue&type=style&index=0&id=36f0659d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports